import { CLIENT_ROLES, OWNER_ROLES, ROLES_IN_RUSSIAN } from '@/constants/roles'
import { hasRoleFromGroup } from '@/utils/auth/roleGroups'

type TokenRoles = readonly string[]

const OWNER_ROLE_NAMES: readonly string[] = Object.values(OWNER_ROLES)
const BUYER_ROLES: readonly string[] = [
  CLIENT_ROLES.USER,
  CLIENT_ROLES.SUPERUSER,
]

export const isSupplierStaff = (tokenRoles: TokenRoles) =>
  hasRoleFromGroup(tokenRoles, 'SUPPLIER_STAFF')

export const isClientUser = (tokenRoles: TokenRoles) =>
  !isSupplierStaff(tokenRoles)

export const isBuyerUser = (tokenRoles: TokenRoles) =>
  isClientUser(tokenRoles) &&
  (tokenRoles.some((role) => BUYER_ROLES.includes(role)) ||
    !tokenRoles.includes(CLIENT_ROLES.PRODUCT_SUPPLIER_USER))

export const isNomenclatureEditor = (tokenRoles: TokenRoles) =>
  tokenRoles.includes(OWNER_ROLES.NOMENCLATURE_EDITOR) &&
  tokenRoles.every(
    (role) =>
      role === OWNER_ROLES.NOMENCLATURE_EDITOR ||
      !OWNER_ROLE_NAMES.includes(role)
  )

export const getMainRoleLabel = (tokenRoles: TokenRoles) => {
  const mainRole = Object.keys(ROLES_IN_RUSSIAN).find((role) =>
    tokenRoles.includes(role)
  )
  return mainRole ? ROLES_IN_RUSSIAN[mainRole] : ''
}
